import { Component } from "react";
import { Link } from "react-router-dom";
import Tooltip from "../ui/Tooltip";
import RectButton from "../ui/button/RectButton";

import "./style.scss";
import SwitchButton from "../ui/button/SwitchButton";
import AppContext from "../../contexts/AppContext";
import EditMainAddressPopup from "../Popup/EditMainAddressPopup";

class SettingsSelect extends Component {
    static contextType = AppContext;
    render() {
        return (
            <div className="acc-settings-select" onClick={this.props.onClick}>
                <div className="content">
                    <div className="user-data">
                        <div className="circle">AK</div>
                        <div className="data">
                            <div className="name">Ari Kaplan</div>
                            <div className="email">ari@griflan.com</div>
                        </div>
                    </div>
                    <Link className="subscribe-bt" to="/subscriptions"><RectButton text="SUBSCRIBE & SAVE UP TO 20%" transparentBgHover={true} noTextHover={true} /></Link>
                    <nav>
                        <div className="row lock">
                            <div className="label"><Link className="uh" to="/">Card Selection</Link></div>
                        </div>
                        <div className="row lock">
                            <div className="label"><Link className="uh" to="/address-book">Address Book</Link></div>
                        </div>
                        <div className="row lock">
                            <div className="label"><Link className="uh" to="/message-templates">Message Templates</Link></div>
                        </div>
                        <div className="row lock">
                            <div className="label"><Link className="uh" to="/past-orders">Past Orders</Link></div>
                        </div>
                        <div className="row lock">
                            <div className="label">Logged with Facebook</div>
                            <div className="info"><div className="action small">Convert</div></div>
                        </div>
                        <div className="row lock">
                            <div className="label">Payment Method</div>
                            <div className="info"><div className="action small"><Link to="payment-methods">Add</Link></div></div>
                        </div>
                        <div className="row lock">
                            <div className="label">Physical Address</div>
                            <div className="info"><div className="action small" onClick={() => {this.context.setPopup(<EditMainAddressPopup />);this.context.setShowUserSettings(false);}}>Edit</div></div>
                            <div className="info full small">
                                <span>4206 Spruce Street</span>
                                <span>Philadelphia, PA 19104</span>
                            </div>
                        </div>
                        <div className="row lock">
                            <div className="label"><span>Remaining Prepay</span><Tooltip text="According to your subscription, your credits will renew <Renewal date>" /></div>
                            <div className="info">$100.00</div>
                        </div>
                        <div className="row lock">
                            <div className="label"><span>Remaining Credits</span></div>
                            <div className="info">$500.00</div>
                        </div>
                        <div className="row lock">
                            <div className="label"><span>Test Mode</span><Tooltip text="Test usage of the system without writing cards. Credit cards are authorized but not charged. Turn on Test Mode during testing of the API." /></div>
                            <div className="info"><SwitchButton onChange={(value)=>this.context.setTestMode(value)} /></div>
                        </div>

                        <div className="row lock">
                            <div className="label uh" onClick={()=>{this.context.setUser(null);}}>Sign Out</div>
                        </div>
                    </nav>
                </div>
            </div>
        )
    }
}

export default SettingsSelect;